import { Button, Modal, Box, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { footerButtonWidth, cancelButtonStyles, registerPatientButtonStyles } from "../../common/commonStyles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";

const ServiceCreationForm = ({
  open,
  handleClose,
  formData,
  handleInputChange,
  handleCreateService,
  isEditClicked,
  validationErrors,
}) => {
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            flexGrow: 1,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "800px",
            maxWidth: "800px",
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <Grid container>
            <Grid item xs={12}>
              <h3 className="form-title">
                {isEditClicked ? "Edit Service" : "Service Creation Form"}{" "}
              </h3>
            </Grid>
          </Grid>
          <Divider sx={{ marginBottom: "20px" }} />
          <Grid container spacing={2}>
            <Grid size={5}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  size="small"
                  margin="normal"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="custom-textfield"
                  error={!!validationErrors.name}
                  helperText={validationErrors.name}
                />
              </Grid>
            </Grid>
            <Grid size={7}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Description"
                  size="small"
                  margin="normal"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  className="custom-textfield"
                  error={!!validationErrors.description}
                  helperText={validationErrors.description}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid size={4}>
              <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  label="Consultation Fee"
                  size="small"
                  margin="normal"
                  name="consultation_fee"
                  value={formData.consultation_fee}
                  onChange={handleInputChange}
                  className="custom-textfield"
                  error={!!validationErrors.consultation_fee}
                  helperText={validationErrors.consultation_fee}
                />
              </Grid>
            </Grid>
            <Grid size={4}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Therapy Session Fee"
                  size="small"
                  margin="normal"
                  name="therapy_session_fee"
                  value={formData.therapy_session_fee}
                  onChange={handleInputChange}
                  className="custom-textfield"
                  error={!!validationErrors.therapy_session_fee}
                  helperText={validationErrors.therapy_session_fee}
                />
              </Grid>
            </Grid>
            <Grid size={4}>
              <Grid item xs={6} sm={6}>
                <TextField
                  fullWidth
                  label="Therapy Duration Minutes"
                  size="small"
                  margin="normal"
                  name="therapy_duration_minutes"
                  value={formData.therapy_duration_minutes}
                  onChange={handleInputChange}
                  className="custom-textfield"
                  error={!!validationErrors.therapy_duration_minutes}
                  helperText={validationErrors.therapy_duration_minutes}
                />
              </Grid>
            </Grid>
          </Grid>
          <div className="register_btn">
            <Button
              variant="contained"
              sx={[registerPatientButtonStyles, footerButtonWidth]}
              size="small"
              onClick={() => {
                handleCreateService();
              }}
            >
              {isEditClicked ? "Edit" : "Create"}
            </Button>
            <Button
              variant="contained"
              sx={[cancelButtonStyles,footerButtonWidth]}
              size="small"
              onClick={() => {
                handleClose();
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ServiceCreationForm;
